import React, { useEffect, useState } from "react";
import cookie from "react-cookies";
import FloatingLabelInput from "react-floating-label-input";
import { ClipLoader } from "react-spinners";
import toast from "react-hot-toast";
import { handleKeyPress } from "../Others/eventHandlers";
import { fetchLocation } from "../Request/LoginRequests";
import { userSignUp } from "../Request/UserRequests";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import {
  saveAddress,
  saveUser,
  setCurrentLocation,
} from "../Redux/Actions/userActions";

function SignUp({ phn }) {
  const [pin, setPin] = useState("");
  const [name, setName] = useState("");
  const [area, setArea] = useState("select");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [disable, setDisable] = useState(true);
  const [areaList, setList] = useState(null);
  const [load, setLoad] = useState(false);
  const [saving, setSaving] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (pin.length === 6) {
      setLoad(true);
      fetchLocation(pin)
        .then((res) => {
          setList(res);
          setArea(res[0].placeName);
          setCity(res[0].adminName3);
          setState(res[0].adminName1);
        })
        .catch(() => toast.error("Invalid Pincode", { id: "err" }))
        .finally(() => setLoad(false));
    } else {
      setList(null);
      setArea("select");
      setCity("");
      setState("");
    }
  }, [pin]);

  useEffect(() => {
    if (
      !name.length ||
      pin.length !== 6 ||
      area === "select" ||
      !city.length ||
      !state.length
    )
      setDisable(true);
    else setDisable(false);
  }, [name, pin, area, city, state]);

  function handleSignUp() {
    setSaving(true);
    userSignUp({
      name,
      phn,
      address: "",
      area,
      city,
      state,
      pin,
    })
      .then((res) => {
        toast.success("Signed Up");
        cookie.save("uid", res.userHash, {
          path: "/",
          expires: new Date(new Date().setDate(new Date().getDate() + 360)),
        });
        dispatch(saveUser({ name, phn, userHash: res.userHash }));
        let cur = {
          name,
          address: "",
          area,
          city,
          state,
          pincode: pin,
          primary: "true",
          addressId: res.addressId,
          lat: areaList.find((el) => el.placeName === area).latitude,
          long: areaList.find((el) => el.placeName === area).longitude,
        };
        dispatch(saveAddress([{ ...cur }]));
        dispatch(setCurrentLocation(cur));
        setSaving(false);
        navigate("/home");
      })
      .catch((err) => {
        toast.error(err);
        setSaving(false);
      });
  }

  return (
    // Signup popup
    <div
      className="round-top w-100 overflow-hidden animate-2 bg-white hide-2 pop-up"
      style={{
        position: "absolute",
        bottom: "0",
        width: "100vw",
      }}
      id="signup"
    >
      {/* Header */}
      <h2 className="popup-header">
        <i className="bi bi-card-checklist fs-5"></i> Sign Up
      </h2>

      {/* Sign up Form */}
      <div className="p-4 bg-white">
        <div className=" mb-3">
          {/* Name */}
          <FloatingLabelInput
            id="name"
            label="Full Name"
            className="fs-5 floating-label animate-2"
            placeholder="Enter Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          </div>
          {/* Phn No */}
          <div className=" mb-3">
          <FloatingLabelInput
            id="phn"
            label="Mobile No."
            className="floating-label animate-2 fs-5 animate-2"
            readOnly
            value={phn}
            />
          </div>
          <div className="d-flex">
            {/* Pincode input */}
            <div className="w-50 mb-3" style={{ position: "relative" }}>
              <FloatingLabelInput
                id="pin"
                label="Pincode"
                type="number"
                className="fs-5 w-100 floating-label animate-2"
                value={pin}
                onKeyDown={(e) => handleKeyPress(e, pin, 6)}
                onChange={(e) => {
                  setPin(e.target.value);
                }}
              />
              <div
                style={{
                  position: "absolute",
                  right: "2px",
                  bottom: "50%",
                  transform: "translate(0%,75%)",
                }}
              >
                <ClipLoader size="15px" color="#e96125" loading={load} />
              </div>
            </div>

            {/* Space */}
            <div className="mx-1"></div>

            {/* Area list */}
            <div className="w-50 mt-1" style={{ position: "relative" }}>
              <span
                className="text-muted px-1 animate-2 fs-5"
                style={{
                  position: "absolute",
                  transform: "translate(0%,-50%) scale(0.7)",
                  transformOrigin: "left center",
                }}
              >
                Area
              </span>
              <select
                className="form-select border-0 border-bottom rounded-0 ps-1 pt-2 pe-4 pb-0 fs-5 animate-2 w-100"
                id="selArea"
                value={area}
                onChange={(e) => setArea(e.target.value)}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "clip",
                  paddingBottom: "1px",
                }}
              >
                {areaList?.length ? (
                  areaList?.map((key, i) => (
                    <option key={i} value={key.placeName}>
                      {key.placeName}
                    </option>
                  ))
                ) : (
                  <option value="select"> --Select-- </option>
                )}
              </select>
            </div>
          </div>
          <div className="d-flex">
            <div className="w-50 mb-3">
              <FloatingLabelInput
                id="city"
                label="City"
                className="floating-label fs-5 w-100"
                readOnly
                value={city}
              />
            </div>
            <div className="mx-1"></div>
            <div className="w-50 mb-3">
              <FloatingLabelInput
                id="state"
                label="State"
                className="floating-label fs-5 w-100"
                readOnly
                value={state}
              />
            </div>
          </div>
        <div className="pt-1">
          <button
            className="w-100 btn-cnf btn-orange animate fs-5 py-2"
            disabled={disable || saving}
            onClick={handleSignUp}
          >
            Sign up
          </button>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
